import React from "react";
import {ChatContextType} from "../types/chat-context";
import {ChatContext} from "../context/chat-context";
import {ChatMetadataContextType} from "../types/chat-metadata-context";
import {ChatMetadataContext} from "../context/chat-metadata-context";

export function useChatMetadataContext(): ChatMetadataContextType {
  return React.useContext(ChatMetadataContext)
}